"use client"
import { AlternatingFeatureSection } from "@/components/alternating-feature-section"
import { useLanguage } from "@/contexts/language-context"
import { Button } from "@/components/ui/button"
import { ArrowRight } from "lucide-react"
import {
  ScenarioTemplatesPreview,
  CustomInputsPreview,
  CutReplyTimePreview,
  CopySharePreview
} from "@/components/previews/previews"
import { useAuth } from '@/contexts/auth-context'
import { GetStartedButton } from '@/components/get-started-button'

export function FeatureSections() {
  const { t } = useLanguage()
  const { isAuthenticated } = useAuth()

  const sections = [
    {
      id: 'feature-scenario',
      title: t('features.scenario.title'),
      eyebrow: t('features.badge'),
      description: t('features.scenario.description'),
      reverse: false,
  media: <div className="max-w-md w-full"><ScenarioTemplatesPreview /></div>
    },
    {
      id: 'feature-custom',
      title: t('features.custom.title'),
      eyebrow: t('features.badge'),
      description: t('features.custom.description'),
      reverse: true,
  media: <div className="max-w-md w-full"><CustomInputsPreview /></div>
    },
    {
      id: 'feature-instant',
      title: t('features.instant.title'),
      eyebrow: t('features.badge'),
      description: t('features.instant.description'),
      reverse: false,
  media: <div className="max-w-md w-full"><CutReplyTimePreview /></div>
    },
    {
      id: 'feature-copy',
      title: t('features.copy.title'),
      eyebrow: t('features.badge'),
      description: t('features.copy.description'),
      reverse: true,
  media: <div className="max-w-md w-full"><CopySharePreview /></div>
    }
  ]

  return (
    <div id="features">
      {sections.map(s => (
        <AlternatingFeatureSection
          key={s.id}
            id={s.id}
            title={s.title}
            eyebrow={s.eyebrow as string}
            description={s.description as string}
            reverse={s.reverse}
            media={s.media}
            primaryCta={!isAuthenticated && (
              <GetStartedButton
                size="lg"
                className="bg-blue-600 hover:bg-blue-700 dark:bg-indigo-500 dark:hover:bg-indigo-600"
                labelKey="hero.cta.tryNow"
              />
            )}
        />
      ))}
    </div>
  )
}

// Placeholder component removed after integrating live previews.
